import { round2, safeNumber } from './math'

/** Desired profit from cost base. */
export class ProfitCalculator {
  calculate(costBase: number, profitPercent: number): number {
    return round2(safeNumber(costBase) * (safeNumber(profitPercent) / 100))
  }

  /** Reverse: profit left when sale is known. */
  fromSale(salePrice: number, purchasePrice: number, operational: number, taxes: number): number {
    return round2(safeNumber(salePrice) - safeNumber(purchasePrice) - safeNumber(operational) - safeNumber(taxes))
  }

  fromAbsolute(value: number): number {
    return round2(safeNumber(value))
  }
}
